import { intervalToDuration } from "date-fns";
import { durationToSeconds } from "./chordProParse";

const LOG_TAG = "⏱️ formatSecondsAsMinutesSeconds";
const DEBUG = true;

export default function formatSecondsAsMinutesSeconds(seconds: number): string {
  if (DEBUG)
    console.debug(LOG_TAG, "formatSecondsAsMinutesSeconds", { seconds });

  // really should run a migration on bad old data
  if (typeof seconds === "string") {
    // biome-ignore lint/style/noParameterAssign: <explanation>
    seconds = durationToSeconds(seconds);
  }

  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  const sec = !duration.seconds
    ? "00"
    : duration.seconds < 10
      ? `0${duration.seconds}`
      : duration.seconds;
  return `${duration.minutes}:${sec}`;
}
